export const headersPlanoTrabalhoOrgInter = [
  { text: '', width: 1, key: 'offCanvas' },
  { text: 'ID', width: 2, key: 'id' },
  { text: 'Produto Farmacêutico', width: 30, key: 'produtoDAF' },
  { text: 'Qtd Estimada', width: 7, key: 'qtdEstimada' },
  { text: 'Valor Unit. R$', width: 7, key: 'valorUnitario' },
  { text: 'Taxa Adm (%)', width: 7, key: 'taxaAdm' },
  { text: 'Valor Frete', width: 7, key: 'valorFrete' },
  { text: 'Valor Total R$', width: 10, key: 'valorTotal' },
];

export const valoresExibidosPlanoTrabalhoOrgInter: Record<string, string> = {
  id: 'ID',
  dataRegistro: 'Data de Registro',
  dataAtualizacao: 'Última Atualização',
  dataUltimaVisualizacao: 'Última Visualização',
  dataUltimaAtualizacao: 'Última Atualização',
  nEdicoes: 'Edições',
  nVisualizacoes: 'Visualizações',
  nVisualizadores: 'Visualizadores',
  usuarioRegistro: 'Responsável pelo Registro',
  usuarioAtualizacao: 'Responsável Ult. Atualização',
  usuarioUltimaVisualizacao: 'Responsável Ult. Visualização',
  observacoes: 'Observações',

  // Fase
  produtoDAF: 'Produto Farmacêutico',
  qtdEstimada: 'Qtd Estimada',
  valorUnitario: 'Valor Unitário R$',
  taxaAdm: 'Taxa Administrativa (%)',
  valorFrete: 'Valor do Frete R$',
  valorTotal: 'Valor Total R$',

  //Separadores
  separador: '',
  separadorLog: '',
  separadorItem: '',
  separadorObservacoes: '',
};

export const fieldObjectPlanoTrabalhoOrgInter = [
  'usuarioRegistro.nomeCompleto',
  'usuarioAtualizacao.nomeCompleto',
  'usuarioUltimaVisualizacao.nomeCompleto',
  'responsavel.nomeCompleto',
  'proaq.id',
  'proaqResponsavel.responsavel',
  'produtoDAF.produtoFarmaceutico',
  'denominacaoGenerica.denominacaoGenerica',
  'KitProdutoDAF.nomeKit',
];
